import { useEffect } from 'react';
import useCrmObjectTypeListingFilters from 'framework-listing-lib/hooks/useCrmObjectTypeListingFilters';
import { useCurrentView, useViewUpdateState } from 'framework-listing-lib/internal/ViewTabs/hooks/useViewProps';
export function ViewFiltersChangedWatcher() {
  const currentView = useCurrentView();
  const {
    isFilterFromCustomView
  } = useCrmObjectTypeListingFilters();
  const [, setViewUpdateState] = useViewUpdateState();
  useEffect(() => {
    if (!currentView) {
      return;
    }
    setViewUpdateState(previousViewUpdateState => {
      const hasChangedFilters = !isFilterFromCustomView;
      if (previousViewUpdateState.changedFilters === hasChangedFilters) {
        return previousViewUpdateState;
      }
      return Object.assign({}, previousViewUpdateState, {
        changedFilters: hasChangedFilters
      });
    });
  }, [currentView, isFilterFromCustomView, setViewUpdateState]);
  return null;
}